import { CONFIG } from '../config';

export default function addTabFocusHandler(KEYCODES, $classTarget, focusClass) {

  document.querySelector('body').classList.add(CONFIG.focus.disabledClass);

  document.addEventListener('keydown', (event) => {
    const key = event.keyCode || event.which;
    if (key === KEYCODES.TAB) {
      $classTarget.classList.add(focusClass);
    }
  }, true);
  document.addEventListener('mousedown', () => {
    $classTarget.classList.remove(focusClass);
  }, true);
  document.addEventListener('touchstart', () => {
    $classTarget.classList.remove(focusClass);
  }, true);
}
